module.exports = __webpack_public_path__ + "img/pt-3.73bf4b72.jpg";